/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const FILENAME = 'exportFileName';

export function downloadFile(data: any, blobType: string, fileName: string) {
  const blob = new Blob([data], {
    type: blobType,
  });

  if (window.navigator.msSaveOrOpenBlob !== undefined) {
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
  }
}
